<template>
    <div v-if="loader" class="active preloader catalog__preloader">
        <div class="preloader-loader"></div>
    </div>
    <div v-else class="checkout-wrapper row">
        <template v-if="count > 0">
            <div class="col-12 col-lg-8 ">
                <div class="checkout-step checkout-step-1">
                    <span class="checkout-label-step">Шаг 1 из 3</span>
                    <h3 class="checkout-label">Контактные данные</h3>
                    <div class="checkout-inputs row">
                        <!-- Имя -->
                        <div class="col-12 col-sm-6 col-xl-4">
                            <div>
                                <span class="input-field-wrapper">
                                  <input
                                      type="text"
                                      placeholder="Имя"
                                      v-model="order.name"
                                      :class="{ invalid: v$.order.name.$dirty &&
                                        (v$.order.name.required.$invalid || v$.order.name.minLength.$invalid)
                                    }"
                                  />
                                </span>
                                <p v-if="v$.order.name.$dirty && v$.order.name.required.$invalid" class="tips error-msg">
                                    Это поле обязательно для заполнения!
                                </p>
                                <p v-else-if="v$.order.name.$dirty && v$.order.name.minLength.$invalid" class="tips error-msg">
                                    Заполните до конца
                                </p>
                                <p v-else class="tips">Например: Иванов Иван Иванович</p>
                            </div>
                        </div>
                        <!-- Телефон -->
                        <div class="col-12 mt-4 mt-sm-0 col-sm-6 col-xl-4">
                            <div>
                                <span class="input-field-wrapper">
                                  <input-mask
                                      v-model="order.phone"
                                      mask="+7 (999) 999-99-99"
                                      maskChar="_"
                                      placeholder="Телефон"
                                      :class="{
                                      invalid: v$.order.phone.$dirty &&
                                        (v$.order.phone.required.$invalid ||
                                        v$.order.phone.minLength.$invalid
                                        )
                                    }"
                                  />
                                </span>
                                <p v-if="v$.order.phone.$dirty && v$.order.phone.required.$invalid" class="tips error-msg">
                                    Это поле обязательно для заполнения!
                                </p>
                                <p v-else-if="v$.order.phone.$dirty && v$.order.phone.minLength.$invalid" class="tips error-msg">
                                    Заполните до конца
                                </p>
                                <p v-else-if="v$.order.phone.$dirty && v$.order.phone.isFullPhone.$invalid" class="tips error-msg">
                                    Заполните номер до конца
                                </p>
                                <p v-else class="tips"></p>
                            </div>
                        </div>
                        <!-- Email -->
                        <div class="col-12 mt-4 col-sm-6 mt-xl-0 col-xl-4">
                            <div>
                                <span class="input-field-wrapper">
                                  <input
                                      type="text"
                                      placeholder="E-mail"
                                      v-model="order.email"
                                      :class="{
                                      invalid: v$.order.email.$dirty &&
                                        (v$.order.email.required.$invalid || v$.order.email.email.$invalid)
                                    }"
                                  />
                                </span>
                                <p v-if="v$.order.email.$dirty && v$.order.email.required.$invalid" class="tips error-msg">
                                    Это поле обязательно для заполнения!
                                </p>
                                <p v-else-if="v$.order.email.$dirty && v$.order.email.email.$invalid" class="tips error-msg">
                                    Неверный формат!
                                </p>
                                <p v-else class="tips"></p>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Способ доставки -->
                <div class="checkout-step checkout-step-2">
                    <span class="checkout-label-step">Шаг 2 из 3</span>
                    <h3 class="checkout-label">Способ доставки</h3>
                    <ShippingSelect />
                    <div v-if="shippingSelect !== 1" class="checkout-shipping-address row">
                        <span class="col-12 mb-3">Адрес</span>
                        <div class="col-12 col-sm-4">
                          <span class="input-field-wrapper">
                            <input
                                type="text"
                                placeholder="Город"
                                v-model="order.address.city"
                                :class="{
                                invalid: v$.order.address.city.$dirty &&
                                  (v$.order.address.city.required.$invalid || v$.order.address.city.minLength.$invalid)
                              }"
                            />
                          </span>
                            <p v-if="v$.order.address.city.$dirty && v$.order.address.city.required.$invalid" class="tips error-msg">
                                Это поле обязательно для заполнения!
                            </p>
                            <p v-else-if="v$.order.address.city.$dirty && v$.order.address.city.minLength.$invalid" class="tips error-msg">
                                Слишком коротко {{ order.address.city.length }} из {{ v$.order.address.city.$params.minLength.min }}
                            </p>
                            <p v-else class="tips"></p>
                        </div>
                        <div class="col-12 mt-4 mt-sm-0 col-sm-8">
                          <span class="input-field-wrapper address">
                            <input
                                type="text"
                                placeholder="Улица, дом, кв"
                                v-model="order.address.other"
                                :class="{
                                invalid: v$.order.address.other.$dirty &&
                                  (v$.order.address.other.required.$invalid || v$.order.address.other.minLength.$invalid)
                              }"
                            />
                          </span>
                            <p v-if="v$.order.address.other.$dirty && v$.order.address.other.required.$invalid" class="tips error-msg">
                                Это поле обязательно для заполнения!
                            </p>
                            <p v-else-if="v$.order.address.other.$dirty && v$.order.address.other.minLength.$invalid" class="tips error-msg">
                                Слишком коротко {{ order.address.other.length }} из {{ v$.order.address.other.$params.minLength.min }}
                            </p>
                            <p v-else class="tips"></p>
                        </div>
                    </div>
                </div>
                <!-- Способ оплаты -->
                <div class="checkout-step checkout-step-3">
                    <span class="checkout-label-step">Шаг 3 из 3</span>
                    <h3 class="checkout-label">Способ оплаты</h3>
                    <PaymentSelect />
                </div>
                <!-- Состав заказа -->
                <div class="checkout-step checkout-step-4">
                    <h3 class="checkout-label">Состав заказа ({{ count }})</h3>
                    <CartPositions :title="'Состав заказа'" :positions="safePositions" />
                </div>
            </div>
            <!-- Sidebar -->
            <div class="col-12 mt-5 mt-lg-0 col-lg-4">
                <div class="wrapper-checkout-side">
                    <div class="checkout-side">
                        <CartTotal
                            :policy=true
                            :price="price"
                            :title="'Сумма заказа'"
                            :linkButton="''"
                            @clickButton="createOrder"
                            :buttonText="'Оформить заказ'"
                        />
                    </div>
                </div>
            </div>
        </template>
        <div v-else class="col-12 cart-empty">
            <h3>Корзина пуста</h3>
            Воспользуйтесь поиском, чтобы найти всё что нужно.
        </div>
    </div>
</template>


<script setup>
import { ref, reactive, computed, nextTick, onMounted } from 'vue'
import useVuelidate from '@vuelidate/core'
import { email, minLength, required, numeric } from '@vuelidate/validators'
import { useStore } from 'vuex'
import axios from "axios";

import ShippingSelect from '../blocks/ShippingTypeSelect.vue'
import PaymentSelect from '../blocks/PaymentTypeSelect.vue'
import CartPositions from '../blocks/CartPositions.vue'
import CartTotal from '../blocks/CartTotal.vue'
import InputMask from 'vue-input-mask'

// --- STORE ---
const store = useStore()
const loader = ref(true)
const currency = ref('₽')

// --- КОРЗИНА ---
const positions = computed(() => Array.isArray(store.getters.cartItems) ? store.getters.cartItems : [])
const price = computed(() => store.getters.price || 0)
const safePositions = computed(() => Array.isArray(positions.value) ? positions.value : [])
const count = computed(() => safePositions.value.length)

// --- ЗАЯВКА ---
const order = reactive({
    isProcess: false,
    name: '',
    phone: '',
    email: '',
    address: { city: '', other: '' }
})
const shippingSelect = computed(() => store.getters.shippingSelect)
const paymentSelect = computed(() => store.getters.paymentSelect)
const isFullPhone = (value) => {
    if (typeof value !== 'string') return false
    return !value.includes('_') && value.length === 18
}

// --- ВАЛИДАЦИЯ ---
const rules = computed(() => {
    const base = {
        name: { required, minLength: minLength(3) },
        phone: { required, minLength: minLength(18), isFullPhone },
        email: { required, email },
        address: {
            city: {},
            other: {}
        }
    }
    if (shippingSelect.value !== 1) {
        base.address.city = { required, minLength: minLength(3) }
        base.address.other = { required, minLength: minLength(5) }
    }
    return { order: base }
})
const v$ = useVuelidate(rules, { order })


const createOrder = async () => {
    // Валидируем
    v$.value.$touch()
    if (v$.value.$invalid) {
        await nextTick()
        const el = document.querySelector('.invalid')
        if (el) {
            const domRect = el.getBoundingClientRect()
            window.scrollTo({
                left: domRect.left + window.scrollX,
                top: domRect.top + window.scrollY - 100,
                behavior: 'smooth'
            })

        }
        return

    }

    // Предотвращаем двойные сабмиты
    if (order.isProcess) return

    try {
        order.isProcess = true

        // Собираем данные заказа
        const data = {
            user: {
                name: order.name,
                phone: order.phone,
                email: order.email
            },
            order: {
                payment_method_id: paymentSelect.value,
                shipping_type_id: shippingSelect.value,
                property: {
                    shipping_city: order.address.city,
                    shipping_address1: order.address.other
                }
            }
        }

        try {
            order.isProcess = true
            loader.value = true
            $.request('MakeOrder::onCreate', {
                'data': data,
                success: function (obResponse) {
                    console.log('testt')
                    ym(68375863, 'reachGoal', 'success')
                    order.isProcess = false
                    loader.value = false
                    if (!obResponse) {
                        return;
                    }
                    if (!!obResponse['X_OCTOBER_REDIRECT']) {
                        return this.success(obResponse);
                    }
                    return this.success(obResponse);
                }
            });
        } catch (e) {
            console.log(e)
        }
    } catch (e) {
        console.log('Ошибка при оформлении заказа:', e)
        alert('Ошибка при отправке заказа. Попробуйте ещё раз.')
    }
}

// --- ИНИЦИАЛИЗАЦИЯ ---
onMounted(async () => {
    await store.dispatch('getCartItems')
    await store.dispatch('getPrice')
    await store.dispatch('getShippingTypes')
    await store.dispatch('getPaymentMethods')
    loader.value = false
})
</script>
